// English content for app
const en = {
  search: 'Search for products',
  mensClothing: "Men's clothing",
  womenClothing: "Women's Clothing",
  jewellery: 'Jewellery',
  electronics: 'Electronics',
  fifty_percent_off: 'Get up to 50%',
  holiday_season: 'For the holiday season',
  thirty_percent_discount_shirts: 'Get up to 30% off shirts',
  login: 'Log in',
  register: 'Register',
  help_center: 'Help Center',
  referral_message: 'Invite a friend and get a discount of 5%',
  add_cart: 'Add to Cart',
  select_color: 'Select Color',
  select_size: 'Select Size',
  quantity: 'Quantity',
  free_shipping: 'Free shipping and Free Returns',
  login_with_google: 'Sign in with Google',
  login_with_fb: 'Login with Facebook',
  login_with_your_account: 'Login to your account',
  access_recommendations: 'Get access to your Orders, Wishlist and Recommendations',
  email_or_username: 'Username/ Mobile No. / Email address',
  password: 'Password',
  username_prompt: 'Enter your Username/ Mobile No. / Email address',
  password_prompt: 'Enter your password',
  remember_me: 'Remember me',
  forgot_password: 'Forgot password?',
  create_account: 'Create account',
  alternate_login: 'Or login with your account',
  enter_keyword_to_search: 'Enter keyword to search',
  no_result_found: 'No result found',
  search_result_for: 'Search result for ',
  page_not_found: 'Page not found',
  settings: 'Settings',
  personal_details: 'Personal Details',
  your_saved_cards: 'Your saved cards',
  full_name: 'Full Name',
  phone_number: 'Phone Number',
  address: 'Address',
  city: 'City',
  pin_code: 'Pin Code',
  state: 'State',
  country: 'Country',
  billing_details: 'Billing Details',
  payment_method: 'Payment Method',
  card: 'Card',
  cash_on_delivery: 'Cash on delivery',
  order_summary: 'Order Summary',
  subTotal: 'Subtotal',
  discount: 'Discount',
  tax: 'Tax @ 12.5%',
  delivery_fee: 'Delivery Fee',
  total: 'Total',
  place_order: 'Place Order',
  remove_from_cart: 'Remove from Cart',
};

export default en;
